import React, { useEffect, useState, useContext } from "react";
import ReactLoading from "react-loading";
import { Table, Input, Button } from "antd";
import { Link } from "react-router-dom";
import { AuthContext } from "../state";
import ManageUrls from "../endpoints/manage_urls";
import config from '../env-config.json';
import { history } from "../history";
const Search = Input.Search;

function ListAgents() {

  const { state } = useContext(AuthContext);
  const manageUrls = new ManageUrls();
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);
  const [totalNumberOfItems, setTotalNumberOfItems] = useState('1');
  const [tableCurrentPage, setTableCurrentPage] = useState('1');
  const [searchTerm, setSearchTerm] = useState('');
  const PAGE_SIZE = 10;


  useEffect(() => {
    fetchAgents();
  }, []);

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code"
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name"
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name"
    },
    {
      title: "Mobile number",
      dataIndex: "mobile",
      key: "mobile"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Cash Pickup Location",
      dataIndex: "cash_pickup_location",
      key: "cash_pickup_location"
    },
  ];

  const fetchAgents = (pageNumber = '1') => {
    setLoading(true);
    
    fetch(manageUrls.getApiUrl() + `cash_pickup_agents/?filter[q]=${searchTerm}&page[size]=${PAGE_SIZE}&page[number]=${pageNumber}`, {
      mode: 'cors',
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'Authorization': 'Bearer ' + state.accessToken,
        'App-Id': config.app_id,
      },
    })
    .then(res => {
      if (res.status >= 400) {
        if(res.status !== 404) {
          window.alert("Failed to fetch agents.");
          history.goBack();
        }
        setLoading(false);
        setAgents([]);
        return Promise.reject("Failed to fetch agents.");
      }

      return res;
    })
    .then(res => res.json())
    .then(res => {
      setAgents(res.data);
      console.log("list of agents:", agents);
      const { pagination: { count, page, pages }} = res.meta

      // set pagination state
      setTotalNumberOfItems(count)
      setTableCurrentPage(page)
      setLoading(false);
    })
  }

  const renderFetching = () => {
    if (loading) {
      return (
        <div className="col-6 offset-sm-3 text-center">
          <p> Fetching agents. Please wait...</p>
          <ReactLoading
            className="searching--spinner--100"
            type={'bars'}
            color={'#154989'}
          />
        </div>
      );
    }
  }

  const getLocation = (agent) => {
    const location = state.cashPickupLocations.find(location => location.value === agent.relationships.cash_pickup_location.data.id);
    return location ? location.key : "Not specified";
  }

  const renderTable = () => {
    if (!loading && (agents.length === 0)) {
      return (
        <h4 style={{textAlign: "center"}}>No Agents</h4>
      );
    } else if (!loading) {
      return (
        <Table
          rowclassNameName={(record, index) =>
            index % 2 === 0 ? "" : "table-even-row"
          }
          size="middle"
          pagination = {{
            current: tableCurrentPage,
            total: totalNumberOfItems,
            pageSize: PAGE_SIZE,
            onChange: (pageNumber, _) => {
              fetchAgents(pageNumber)
            }
          }}
          className="table table-hover table-striped"
          bordered
          rowKey="id"
          dataSource={agents.map(agent => ({
              id: agent.id,
              code: agent.attributes.code,
              email: agent.attributes.email,
              first_name: agent.attributes.first_name,
              middle_name: agent.attributes.middle_name,
              last_name: agent.attributes.last_name,
              is_editable: agent.attributes.is_editable,
              mobile: `+${agent.attributes.mobile[0]}${agent.attributes.mobile[1]}`,
              cash_pickup_location: getLocation(agent),
              country: agent.relationships.country.data.id,
            })
          )}
          columns={columns}
          onRow={agent => {
            return {
              onClick: () => {
                history.push({
                  pathname: `/agents/${agent.id}`,
                });
              }
            };
          }}
        />
      );
    }
  }
  
  return (
    <div className="our-causes pt-0">
      <div className="my-content">
        <div className="row">
          <div className="col-12 ">
            <div className="cause-wrap">
              <div className="cause-content-wrap">
                <div className="entry-content">
                  <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignContent: "center", margin: "5px 0"}}>
                    <h1>List Agents</h1>
                    <div style={{display: "flex", flexBasis: "row", gap: 10}}>
                      <div style={{border: "1px solid black", borderRadius: 4}} >
                        <Search
                          placeholder="Search agent and press 'Enter'"
                          onChange={e => setSearchTerm(e.target.value)}
                          onSearch={() => fetchAgents()}
                          className="search"
                        />
                      </div>
                      <Link to="add-agent">Add Agent</Link>
                    </div>
                  </div>
                  {renderFetching()}
                  {renderTable()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListAgents;